import React from 'react';

const FlowChartGraphArea = ({ showCodeEditor, codePanelWidth, graphContainerRef, gridIcon }) => {
  return (
    <div
      style={{
        flex: 1,
        minWidth: 0,
        flexShrink: 1,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Top Ruler (Horizontal) */}
      <div
        id="top-ruler"
        style={{
          height: 18,
          background: '#2d2d2d',
          borderBottom: '1px solid #3e3e42',
          position: 'relative',
          flexShrink: 0,
          zIndex: 10,
          overflow: 'hidden',
          userSelect: 'none',
        }}
      />

      {/* Graph Container with Left Ruler */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Left Ruler (Vertical) */}
        <div
          id="left-ruler"
          style={{
            width: 20,
            background: '#2d2d2d',
            borderRight: '1px solid #3e3e42',
            position: 'relative',
            flexShrink: 0,
            zIndex: 10,
            overflow: 'hidden',
            userSelect: 'none',
          }}
        />

        {/* Graph Container */}
        <div
          ref={graphContainerRef}
          style={{
            flex: 1,
            position: 'relative',
            transition: 'flex 0.3s ease',
          }}
        />
      </div>
    </div>
  );
};

export default FlowChartGraphArea;
